export default interface PasswordInfoType {
  password: string
  passwordConfirm: string
}

export const initPasswordInfo = {
  password: '',
  passwordConfirm: '',
}
